"use client"

import { useState, useEffect } from "react"
import { Play, Calendar, Search } from "lucide-react"
import { apiRequest } from "../lib/utils"

export default function VideosPage() {
  const [videos, setVideos] = useState([])
  const [loading, setLoading] = useState(true)
  const [searchTerm, setSearchTerm] = useState("")

  useEffect(() => {
    fetchVideos()
  }, [])

  const fetchVideos = async () => {
    try {
      setLoading(true)
      const response = await apiRequest("/api/videos")
      setVideos(response.videos || [])
    } catch (error) {
      console.error("Failed to fetch videos:", error)
    } finally {
      setLoading(false)
    }
  }

  const filteredVideos = videos.filter(
    (video) =>
      video.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (video.description && video.description.toLowerCase().includes(searchTerm.toLowerCase())),
  )

  // const VideoCard = ({ video }) => (
  //   <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
  //     <div className="relative group">
  //       <img src={video.thumbnail || "/placeholder.svg"} alt={video.title} className="w-full h-48 object-cover" />
  //       <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
  //         <a
  //           href={video.youtubeUrl}
  //           target="_blank"
  //           rel="noopener noreferrer"
  //           className="bg-white bg-opacity-90 rounded-full p-4 hover:bg-opacity-100 transition-all transform hover:scale-110"
  //         >
  //           <Play className="w-8 h-8 text-red-600" />
  //         </a>
  //       </div>
  //       <div className="absolute top-4 right-4 bg-black bg-opacity-70 text-white px-2 py-1 rounded text-sm">Video</div>
  //     </div>

  //     <div className="p-6">
  //       <h3 className="text-lg font-semibold text-gray-900 mb-2 line-clamp-2">{video.title}</h3>
  //       {video.description && <p className="text-gray-600 text-sm mb-4 line-clamp-3">{video.description}</p>}

  //       <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
  //         <div className="flex items-center space-x-1">
  //           <Calendar className="w-4 h-4" />
  //           <span>{new Date(video.createdDate).toLocaleDateString()}</span>
  //         </div>
  //       </div>

  //       <a
  //         href={video.youtubeUrl}
  //         target="_blank"
  //         rel="noopener noreferrer"
  //         className="w-full gradient-purple text-white py-3 px-4 rounded-lg hover:opacity-90 transition-opacity flex items-center justify-center space-x-2 font-semibold"
  //       >
  //         <Play className="w-4 h-4" />
  //         <span>Watch Video</span>
  //       </a>
  //     </div>
  //   </div>
  // )

  const VideoCard = ({ video }) => {
    const [isPlaying, setIsPlaying] = useState(false)
  
    return (
      <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
        <div
          className="relative group cursor-pointer"
          onMouseEnter={() => setIsPlaying(true)}
          onMouseLeave={() => setIsPlaying(false)}
          onClick={() => setIsPlaying(!isPlaying)}
        >
          {!isPlaying ? (
            <>
              <img
                src={video.thumbnail || "/placeholder.svg"}
                alt={video.title}
                className="w-full h-48 object-cover"
              />
              <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="bg-white bg-opacity-90 rounded-full p-4 hover:bg-opacity-100 transition-all transform hover:scale-110">
                  <Play className="w-8 h-8 text-red-600" />
                </div>
              </div>
              <div className="absolute top-4 right-4 bg-black bg-opacity-70 text-white px-2 py-1 rounded text-sm">
                Video
              </div>
            </>
          ) : (
            <iframe
              className="w-full h-48"
              src={`${video.youtubeUrl.replace("watch?v=", "embed/")}?autoplay=1`}
              title={video.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          )}
        </div>
  
        <div className="p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-2 line-clamp-2">
            {video.title}
          </h3>
          {video.description && (
            <p className="text-gray-600 text-sm mb-4 line-clamp-3">
              {video.description}
            </p>
          )}
  
          <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
            <div className="flex items-center space-x-1">
              <Calendar className="w-4 h-4" />
              <span>{new Date(video.createdDate).toLocaleDateString()}</span>
            </div>
          </div>
  
          <a
          href={video.youtubeUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full gradient-purple text-white py-3 px-4 rounded-lg hover:opacity-90 transition-opacity flex items-center justify-center space-x-2 font-semibold"
        >
          <Play className="w-4 h-4" />
          <span>Watch Video</span>
        </a>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">शैक्षणिक व्हिडिओ</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          आपले आरोग्य — आता आपल्या हाती: फिटनेस, पोषण आणि मानसिक आरोग्यासाठी व्हिडिओ
          </p>
        </div>

        {/* Search */}
        <div className="max-w-md mx-auto mb-8">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            <input
              type="text"
              placeholder="व्हिडिओ शोधा..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
            />
          </div>
        </div>

        {/* Videos Grid */}
        {loading ? (
          <div className="text-center py-12">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600 mx-auto"></div>
            <p className="text-gray-600 mt-2">व्हिडिओ लोड करत आहे...</p>
          </div>
        ) : filteredVideos.length === 0 ? (
          <div className="text-center py-12">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Play className="w-8 h-8 text-gray-400" />
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              {searchTerm ? "कोणतेही व्हिडिओ सापडले नाहीत" : "अद्याप कोणतेही व्हिडिओ नाहीत"}
            </h3>
            <p className="text-gray-600">{searchTerm ? "कृपया वेगळे शब्द वापरून शोधा" : "लवकरच नवीन व्हिडिओ जोडले जातील"}</p>
          </div>
        ) : (
          <>
            <div className="text-center mb-8">
              <p className="text-gray-600">
                {filteredVideos.length} व्हिडिओ उपलब्ध {searchTerm && `"${searchTerm}" साठी`}
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredVideos.map((video) => (
                <VideoCard key={video.id} video={video} />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  )
}
